// Dữ liệu cho BOT chăm sóc khách hàng (khung chat góc phải màn hình).
// Câu khách tự gõ: gửi lên trợ lý AI (Gemini/OpenAI, chọn ở backend bằng SUPPORT_CHAT_AI_PROVIDER).
// AI tắt, lỗi hoặc quá giới hạn thì BOT chạy trên trình duyệt: so khớp từ khóa với các chủ đề bên dưới.
// Nút gợi ý chủ đề luôn trả lời bằng BOT từ khóa (tức thì, không tốn phí AI).
// Câu nào không khớp thì mời khách chuyển sang Zalo để tư vấn viên trả lời.

import { PAYMENT_ENABLED } from './payment.js';

export const SUPPORT_HOTLINE = '0812539539';
export const SUPPORT_HOTLINE_DISPLAY = '0812.539.539';
export const SUPPORT_ZALO_URL = `https://zalo.me/${SUPPORT_HOTLINE}`;

export const BOT_GREETING =
  'Chào anh/chị 👋 Em là trợ lý tự động của daotaonhathuoc.com (Thế Thảo Pharma). Anh/chị cần hỗ trợ gì ạ? Chọn một chủ đề bên dưới hoặc gõ câu hỏi.';

export const BOT_FALLBACK =
  'Câu này em chưa trả lời được. Anh/chị bấm "Chat Zalo với tư vấn viên" bên dưới, đội ngũ Thế Thảo Pharma sẽ phản hồi trong giờ hành chính ạ.';

// Mỗi chủ đề:
// - id: định danh; 'pricing' được component xử lý riêng để lấy bảng giá thật từ API /plans
// - label: chữ trên nút gợi ý
// - keywords: từ khóa KHÔNG DẤU, viết thường (câu hỏi của khách cũng được bỏ dấu trước khi so khớp)
// - answer: câu trả lời; actions: nút điều hướng nội bộ (to) hoặc link ngoài (href)
export const BOT_TOPICS = [
  {
    id: 'pricing',
    label: 'Gói học & học phí',
    keywords: ['gia', 'hoc phi', 'bao nhieu tien', 'goi hoc', 'goi nao', 'bang gia', 'chi phi', 'phi'],
    answer: PAYMENT_ENABLED
      ? 'Hiện có gói Miễn phí và các gói trả phí theo giai đoạn phát triển nhà thuốc. Xem chi tiết quyền lợi từng gói tại trang Bảng giá.'
      : 'Nền tảng đang trong giai đoạn thử nghiệm miễn phí: anh/chị đăng ký tài khoản là học được ngay các module nền tảng, không mất phí. Các gói hội viên sẽ mở đăng ký khi kết thúc giai đoạn thử nghiệm.',
    actions: [{ label: 'Xem bảng giá', to: '/courses?tab=pricing' }],
  },
  {
    id: 'free',
    label: 'Học miễn phí',
    keywords: ['mien phi', 'free', 'hoc thu', 'khong mat tien', '0d', '0 dong'],
    answer:
      'Anh/chị chỉ cần đăng ký tài khoản (số điện thoại/Zalo + tỉnh thành) là học được ngay 7 module nền tảng, kèm toàn bộ biểu mẫu đính kèm và bản tin pháp lý định kỳ.',
    actions: [
      { label: 'Đăng ký học miễn phí', to: '/register' },
      { label: 'Xem chương trình', to: '/courses' },
    ],
  },
  {
    id: 'payment',
    label: 'Thanh toán / kích hoạt gói',
    keywords: [
      'thanh toan',
      'chuyen khoan',
      'qr',
      'kich hoat',
      'chua thay goi',
      'chua kich hoat',
      'mua goi',
      'nap tien',
      'hoa don',
    ],
    answer: PAYMENT_ENABLED
      ? 'Thanh toán bằng chuyển khoản quét mã VietQR. Chọn gói ở trang Bảng giá → quét QR → giữ nguyên trang đến khi hiện "Thanh toán thành công", gói được kích hoạt tự động.\n\nNếu đã chuyển khoản mà lỡ đóng trang thì KHÔNG chuyển lại, hệ thống tự đối soát trong vài phút. Sau 30 phút vẫn chưa thấy gói, anh/chị nhắn Zalo kèm ảnh chụp giao dịch ạ.'
      : 'Thanh toán trực tuyến đang được triển khai, sẽ sớm mở. Hiện tại anh/chị muốn đăng ký gói trả phí vui lòng bấm "Chat Zalo với tư vấn viên" bên dưới để được hỗ trợ ạ.',
    actions: PAYMENT_ENABLED ? [{ label: 'Chọn gói', to: '/courses?tab=pricing' }] : [],
  },
  {
    id: 'account',
    label: 'Tài khoản / đăng nhập',
    keywords: [
      'dang nhap',
      'dang ky',
      'tai khoan',
      'mat khau',
      'quen',
      'login',
      'khong vao duoc',
      'doi thong tin',
    ],
    answer:
      'Đăng ký tài khoản ở trang Đăng ký; đổi thông tin hoặc đổi mật khẩu trong trang Hồ sơ cá nhân sau khi đăng nhập.\n\nQuên mật khẩu hoặc không đăng nhập được: anh/chị nhắn Zalo kèm số điện thoại đã đăng ký để đội ngũ hỗ trợ cấp lại ạ.',
    actions: [
      { label: 'Đăng nhập', to: '/login' },
      { label: 'Hồ sơ cá nhân', to: '/profile' },
    ],
  },
  {
    id: 'paths',
    label: 'Lộ trình học',
    keywords: ['lo trinh', 'khoa hoc', 'chuong trinh', 'module', 'bai hoc', 'hoc gi', 'mo nha thuoc', 'gpp'],
    answer:
      'Chương trình chia theo lộ trình: Lộ trình 1 dành cho người sắp mở nhà thuốc/quầy thuốc (hồ sơ GPP, setup ban đầu), Lộ trình 2 cho chủ nhà thuốc đang vận hành muốn tăng trưởng doanh thu, và các chuyên đề nâng cao.',
    actions: [
      { label: 'Xem lộ trình', to: '/courses?tab=paths' },
      { label: 'Xem chuyên đề', to: '/courses' },
    ],
  },
  {
    id: 'tools',
    label: 'Công cụ cho nhà thuốc',
    keywords: [
      'cong cu',
      'tool',
      'sop',
      'quy trinh',
      'luong',
      'thuong',
      'trac nghiem',
      'suc khoe nha thuoc',
      'chuong trinh ban hang',
      'khuyen mai',
      'video',
    ],
    answer:
      'Website có bộ công cụ thực chiến cho nhà thuốc: xây quy trình S.O.P, đo lường sức khỏe nhà thuốc, trắc nghiệm kỹ năng đứng quầy, cơ chế lương thưởng, lên chương trình bán hàng, tạo video hàng loạt…',
    actions: [{ label: 'Xem bộ công cụ', to: '/tools' }],
  },
  {
    id: 'partner',
    label: 'Gói Đối tác (B2B)',
    keywords: ['doi tac', 'b2b', 'khach hang the thao', 'nhan vien quay', 'dao tao nhan vien', 'doanh nghiep'],
    answer:
      'Gói Đối tác dành cho khách hàng B2B của Thế Thảo Pharma đạt hạn mức: tặng kèm đặc quyền học tập, không phát sinh chi phí, có hỗ trợ đào tạo trực tiếp cho nhân viên quầy. Anh/chị nhắn Zalo để được kiểm tra điều kiện ạ.',
    actions: [],
  },
  {
    id: 'contact',
    label: 'Liên hệ / địa chỉ',
    keywords: ['lien he', 'dia chi', 'hotline', 'so dien thoai', 'sdt', 'van phong', 'o dau', 'gap', 'tu van'],
    answer: `Hotline / Zalo: ${SUPPORT_HOTLINE_DISPLAY}\nĐịa chỉ: 60B Nguyễn Huy Tưởng, Thanh Xuân, Hà Nội\nCộng đồng: Nhóm Facebook "Nhà Thuốc & Dược Sĩ 5.0".`,
    actions: [
      { label: `Gọi ${SUPPORT_HOTLINE_DISPLAY}`, href: `tel:${SUPPORT_HOTLINE}` },
      { label: 'Vào cộng đồng', href: 'https://www.facebook.com/groups/934460299578977' },
    ],
  },
];

// Bỏ dấu tiếng Việt + viết thường để so khớp từ khóa
export function normalizeVietnamese(text) {
  return (text || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

// Chủ đề có nhiều từ khóa khớp nhất (từ khóa dài được cộng điểm cao hơn), không khớp thì trả null
export function findBotTopic(question) {
  const q = ` ${normalizeVietnamese(question)} `;
  let best = null;
  let bestScore = 0;
  BOT_TOPICS.forEach((topic) => {
    const score = topic.keywords.reduce(
      (sum, kw) => (q.includes(` ${kw} `) ? sum + kw.length : sum),
      0
    );
    if (score > bestScore) {
      best = topic;
      bestScore = score;
    }
  });
  return best;
}

// Nút điều hướng trợ lý AI được phép gợi ý: AI trả về id, giao diện đổi thành nút.
// Danh sách id phải khớp SUPPORT_CHAT_ACTION_IDS ở back-end/src/data/support-chat-knowledge.data.js
export const SUPPORT_CHAT_ACTIONS = {
  register: { label: 'Đăng ký học miễn phí', to: '/register' },
  login: { label: 'Đăng nhập', to: '/login' },
  profile: { label: 'Hồ sơ cá nhân', to: '/profile' },
  courses: { label: 'Xem chuyên đề', to: '/courses' },
  paths: { label: 'Xem lộ trình', to: '/courses?tab=paths' },
  pricing: { label: 'Xem bảng giá', to: '/courses?tab=pricing' },
  tools: { label: 'Xem bộ công cụ', to: '/tools' },
  tool_health: { label: 'Đo sức khỏe nhà thuốc', to: '/tools/do-luong-suc-khoe' },
  tool_sop: { label: 'Bộ quy trình SOP', to: '/tools/quan-tri-thuc-chien' },
  tool_quiz: { label: 'Trắc nghiệm kỹ năng', to: '/tools/trac-nghiem-thuc-chien' },
  tool_salary: { label: 'Cơ chế lương thưởng', to: '/tools/co-che-luong-thuong' },
  tool_campaign: { label: 'Chương trình bán hàng', to: '/tools/chuong-trinh-ban-hang' },
  tool_video: { label: 'Tạo video hàng loạt', to: '/tools/tao-video-hang-loat' },
  zalo: { label: 'Chat Zalo tư vấn viên', href: SUPPORT_ZALO_URL },
  call: { label: `Gọi ${SUPPORT_HOTLINE_DISPLAY}`, href: `tel:${SUPPORT_HOTLINE}` },
  community: { label: 'Vào cộng đồng', href: 'https://www.facebook.com/groups/934460299578977' },
};
